/**
 * Row reducer for the CPT table's "Auth#" (authorization number) cell.
 * @module updateRowData/authorizationNumberReducer
 */
import { CptCodeWithDetailsKeys } from "../../../../../../enums/tableColumnKeys";
import { checkIfAuthNumberFieldHasError } from "../computeErrorStates";

/**
 * Patches the authorization-number cell's `data` for a single row and
 * recomputes its error flag against the row's current PA-required status.
 *
 * @param rowDataToUpdate - The current row data object to clone and patch.
 * @param updatedData - The new authorization-number string entered in the cell.
 * @returns The row data with `AuthorizationNumber.data` and `hasError` replaced.
 */
export const updateRowDataForAuthorizationNumber = (
  rowDataToUpdate: any,
  updatedData: any,
) => {
  const hasError = checkIfAuthNumberFieldHasError(
    updatedData,
    rowDataToUpdate[CptCodeWithDetailsKeys.PaRequired]?.currentStatusId,
  );
  return {
    ...rowDataToUpdate,
    [CptCodeWithDetailsKeys.AuthorizationNumber]: {
      ...rowDataToUpdate[CptCodeWithDetailsKeys.AuthorizationNumber],
      data: updatedData,
      hasError: hasError,
    },
  };
};
